import React, { useEffect, useState } from "react";
import { PageHeader } from "@ant-design/pro-layout";
import { Row, Col, Button, Modal } from "antd";
import Notifications from "./Notifications";
import AccountSetting from "./AccountSetting";
import Locations from "./Locations";
import { withRouter } from "react-router";
import { useSelector } from "react-redux";
import API from "../../../utils/API/API";
import {
  SwapOutlined,
  CheckCircleOutlined,
  RocketOutlined,
} from "@ant-design/icons";
const PageHeaderContainer = (props) => {
  const currentLocation = props.history.location.pathname;
  const [openSwapVersionModal, setOpenSwapVersionModal] = useState(false);
  const isNewCalendarVersion = localStorage.getItem("isNewCalendarVersion")
    ? JSON.parse(localStorage.getItem("isNewCalendarVersion"))
    : false;
  const swapVersion = () => {
    localStorage.setItem("isNewCalendarVersion", !isNewCalendarVersion);
    const params = new URLSearchParams(props.history.location.search);
    if (params.has("pop-up-new-calendar-version")) {
      params.delete("pop-up-new-calendar-version");
      props.history.replace({
        search: params.toString(),
      });
    }
    window.location.reload();
  };

  const removePopUpVersionInUrl = () => {
    const params = new URLSearchParams(props.history.location.search);
    if (params.has("pop-up-new-calendar-version")) {
      params.delete("pop-up-new-calendar-version");
      props.history.replace({
        search: params.toString(),
      });
    }
  };

  const handleAgreeToNewVersion = () => {
    localStorage.setItem("isAlreadySuggestedNewVersion", true);
    localStorage.setItem("isNewCalendarVersion", true);
    removePopUpVersionInUrl();
    window.location.reload();
  };

  const handleDisagreeToNewVersion = () => {
    localStorage.setItem("isAlreadySuggestedNewVersion", true);
    localStorage.setItem("isNewCalendarVersion", false);
    removePopUpVersionInUrl();
    setOpenSwapVersionModal(false);
  };

  useEffect(() => {
    const params = new URLSearchParams(props.history.location.search);
    if (
      params.get("pop-up-new-calendar-version") === "true" &&
      !isNewCalendarVersion
    ) {
      setOpenSwapVersionModal(true);
    }
  }, [props.history.location.search, isNewCalendarVersion]);

  useEffect(() => {
    API.get("/api/business/get-country")
      .then((res) => {
        if (res.data && res.data.business) {
          const { business } = res.data || {};
          localStorage.setItem("business", JSON.stringify(business));
        }
      })
      .catch((error) => {
        console.error("Failed to fetch country:", error);
      });
    API.get("/api/holiday/get-active")
      .then((res) => {
        if (res.data) {
          localStorage.setItem("holidaysAndSHours", JSON.stringify(res.data));
        }
      })
      .catch((error) => {
        console.error("Failed to fetch holidays and special hours:", error);
      });
  }, []);

  const titles = [
    "Checked in",
    "Account",
    "Checked in",
    "Appointments",
    "Calendar",
    "Time Clock",
    "Settings",
    "Meta",
    "Clients",
    "History",
    "Hours",
    "Menu",
    "Staffs",
    "Taxes",
    "Reports",
    "Gift cards",
    "Holidays",
    "Clover",
    "Referral",
    "Gift Card",
  ];
  const subtitles = [
    "",
    "Business Information",
    "",
    "",
    "",
    "Staff Clock in/out",
    "",
    "",
    "Appointments/Revenues/Reviews",
    "Setting business hours",
    "Manage services",
    "Staff management",
    "Taxes settings",
    "",
    "Gift cards management",
    "Manage days off",
    "Payment integration",
    "Refer other salons",
    "",
  ];
  let currentIndex = 3;
  titles.forEach((title, index) => {
    if (currentLocation.replace(/-/g, " ").includes(title.toLowerCase())) {
      currentIndex = index;
    }
  });
  const { isMobile } = useSelector((state) => state.responsive);
  return (
    <PageHeader
      title={
        titles[currentIndex] === "Appointments" ? (
          <div>
            <span>{isMobile ? "Appts." : "Appointments"}</span>
            <Button
              style={{ marginLeft: 10 }}
              type="link"
              icon={<SwapOutlined />}
              onClick={() => setOpenSwapVersionModal(true)}
            >
              {!isMobile &&
                `Swap to ${isNewCalendarVersion ? "Old" : "New"} Version`}
            </Button>
            <Modal
              open={openSwapVersionModal}
              footer={null}
              onCancel={() => setOpenSwapVersionModal(false)}
              width={460}
              centered
            >
              {isNewCalendarVersion ? (
                <div style={{ textAlign: "center", padding: "28px 20px 16px" }}>
                  <SwapOutlined
                    style={{ fontSize: 36, color: "#8c8c8c", marginBottom: 14 }}
                  />
                  <h2
                    style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}
                  >
                    Switch Back to Classic Calendar?
                  </h2>
                  <p
                    style={{
                      color: "#8c8c8c",
                      marginBottom: 28,
                      lineHeight: 1.6,
                    }}
                  >
                    You're on the new calendar. You can switch back to the
                    classic version anytime.
                  </p>
                  <div
                    style={{
                      display: "flex",
                      gap: 12,
                      justifyContent: "center",
                    }}
                  >
                    <Button size="large" onClick={swapVersion}>
                      Switch to Classic
                    </Button>
                    <Button
                      type="primary"
                      size="large"
                      onClick={() => setOpenSwapVersionModal(false)}
                    >
                      Stay on New Calendar
                    </Button>
                  </div>
                </div>
              ) : (
                <div style={{ padding: "28px 24px 16px" }}>
                  <div style={{ textAlign: "center", marginBottom: 24 }}>
                    <div
                      style={{
                        width: 56,
                        height: 56,
                        borderRadius: "50%",
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 16px",
                      }}
                    >
                      <RocketOutlined style={{ fontSize: 24, color: "#fff" }} />
                    </div>
                    <h2
                      style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}
                    >
                      Try the New Calendar!
                    </h2>
                    <p style={{ color: "#8c8c8c", lineHeight: 1.6, margin: 0 }}>
                      Experience our redesigned calendar with better performance
                      and new features.
                    </p>
                  </div>
                  <div
                    style={{
                      background: "#f5f5ff",
                      borderRadius: 8,
                      padding: "14px 20px",
                      marginBottom: 24,
                    }}
                  >
                    {[
                      "Faster loading and smoother navigation",
                      "Improved week and day views",
                      "Better appointment management",
                    ].map((feature) => (
                      <div
                        key={feature}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          marginBottom: 10,
                        }}
                      >
                        <CheckCircleOutlined
                          style={{
                            color: "#52c41a",
                            fontSize: 15,
                            flexShrink: 0,
                          }}
                        />
                        <span style={{ color: "#595959", fontSize: 14 }}>
                          {feature}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: 12,
                      justifyContent: "center",
                    }}
                  >
                    <Button size="large" onClick={handleDisagreeToNewVersion}>
                      Stay on Current
                    </Button>
                    <Button
                      type="primary"
                      size="large"
                      onClick={handleAgreeToNewVersion}
                    >
                      Try New Calendar
                    </Button>
                  </div>
                </div>
              )}
            </Modal>
          </div>
        ) : (
          titles[currentIndex]
        )
      }
      subTitle={!isMobile && subtitles[currentIndex]}
      className="site-page-header-container"
      style={{ padding: "10px" }}
      // tags={<Row style={{ width: "200px" }}>
      //     <Locations key="Locations" history={props.history} />
      // </Row>}
      extra={
        <div>
          <Row justify="end" align="middle" style={{ flexWrap: "nowrap" }}>
            <Col>
              <Locations key="Locations" history={props.history} />
            </Col>
            <Col>
              <Notifications key="Notification" history={props.history} />
            </Col>
            <Col>
              <AccountSetting key="AccountSettings" history={props.history} />
            </Col>
          </Row>
        </div>
      }
    />
  );
};

export default withRouter(PageHeaderContainer);
